import React from 'react'
import { DashboardProvider } from './Context'
import { Layout } from './layout'

export const DashboardPage = () => {
  return (
    <DashboardProvider>
      <Layout />
    </DashboardProvider>
  )
}
